module.exports = __webpack_public_path__ + "static/media/boitesTupp_01_full.380577f3.gif";